const header = document.querySelector('#global-header')

const dropdownToggles = header
    ? Array.from(header.querySelectorAll('[aria-controls]'))
    : []

const searchForm = header
    ? header.querySelector('#search-form')
    : null

const setStickyState = () => {
    if (!header)
        return

    const scrollY = 'scrollY' in window
        ? window.scrollY
        : ('pageYOffset' in window
            ? window.pageYOffset
            : null)

    if (typeof scrollY !== 'number')
        return

    const isReady = header.classList.contains('ready')

    const headerHeight = header.clientHeight
        + ((searchForm || {}).clientHeight || 0)

    const isDisable = (headerHeight / window.innerHeight) > 0.3

    const disableClassname = 'sticky-disabled'

    if ((isDisable
                && !header.classList.contains(disableClassname))
            || (!isDisable
                && header.classList.contains(disableClassname)))
        header.classList[isDisable ? 'add' : 'remove'](disableClassname)

    const stickyClassname = 'sticky'
    const unstickyClassname = 'unsticky'

    if (scrollY < 2
            && header.classList.contains(stickyClassname)) {
        header.classList.add(unstickyClassname)
        header.classList.remove(stickyClassname)
        setTimeout(() => {
            if (header.classList.contains('focus-active'))
                header.classList.remove('focus-active')

            header.classList.remove(unstickyClassname)
        }, 1)
    }

    if (scrollY >= 2
            && !header.classList.contains(stickyClassname))
        header.classList.add(stickyClassname)

    if (!isReady)
        header.classList.add('ready')
}

const setFocusState = (e = {}) => {
    const target = (e.type === 'focusout'
            && e.relatedTarget
        ? e.relatedTarget
        : e.target) || document.activeElement

    const isFocus = e.type !== 'focusout'
        && (target === header
            || header.contains(target))

    const focusClassname = 'focus-active'

    if ((isFocus
                && !header.classList.contains(focusClassname))
            || (!isFocus
                && header.classList.contains(focusClassname)))
        header.classList[isFocus ? 'add' : 'remove'](focusClassname)
}

dropdownToggles
    .forEach((el) => {
        const getDropdown = (_el) => _el && _el.getAttribute('aria-controls')
            ? document.querySelector(`#${_el.getAttribute('aria-controls')}`)
            : null

        const dropdown = getDropdown(el)

        if (!dropdown)
            return

        if (el.getAttribute('aria-expanded') === 'true') {
            header.classList.add('dropdown-active')
            el.parentElement.classList.add('active')
        }

        el.addEventListener('click', () => {
            const current = header.querySelector('[aria-expanded="true"]')
            const input = dropdown.querySelector('input')

            if (current)
                header.classList.remove('dropdown-init')

            if (current && current !== el) {
                current.setAttribute('aria-expanded', false)
                current.parentElement.classList.remove('active')

                if (getDropdown(current))
                    getDropdown(current).classList.remove('active')
            }

            if (!current)
                header.classList.add('dropdown-init')

            const isExpand = el.getAttribute('aria-expanded') !== 'true'

            el.setAttribute('aria-expanded', isExpand)

            el.parentElement.classList[isExpand ? 'add' : 'remove']('active')
            dropdown.classList[isExpand ? 'add' : 'remove']('active')
            header.classList[isExpand ? 'add' : 'remove']('dropdown-active')

            if (!isExpand && header.classList.contains('focus-active'))
                header.classList.remove('focus-active')

            if (isExpand && input)
                setTimeout(() => input.focus(), 1)
        })
    })

document
    .addEventListener('focusin', setFocusState)

document
    .addEventListener('focusout', setFocusState)

window.addEventListener('load', () => {
    setStickyState()

    let width = window.innerWidth
    let resizeDebounce = null

    window.addEventListener('resize', () => {
        if (width !== window.innerWidth)
            header.setAttribute('data-resizing', true)

        setStickyState()

        clearTimeout(resizeDebounce)

        resizeDebounce = setTimeout(() => {
            width = window.innerWidth
            header.removeAttribute('data-resizing')
        }, 200)
    })

    window.addEventListener('scroll', setStickyState)
})
